import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M12 15l-4 -4h8z","key":"svg-1"}]]

const IconCircleCaretDown = createReactComponent('outline', 'circle-caret-down', 'CircleCaretDown', __iconNode);

export default IconCircleCaretDown;